import { myAxios } from "../../utils/serverContextPath";

// =======================================================
// CRUD
// =======================================================

export const postConsultationRequest = (data) => {
    return myAxios.post("consultationrequest/save/insert", data);
};

export const updateConsultationRequest = (data) => {
    return myAxios.post("consultationrequest/save/update", data);
};

export const getConsultationRequestById = (id) => {
    return myAxios.get(`consultationrequest/getbyid/${id}`);
};

export const getConsultationRequestAllPage = (
    keyword = "",
    pageNumber = 0,
    itemsPerPage = 10,
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("consultationrequest/getallpage", {
        params: {
            keyword,
            page: pageNumber,
            size: itemsPerPage,
            sortList,
            sortOrder
        }
    });

};


export const getConsultationRequestBySenderId = (
    senderId,
    keyword = "",
    tauxsimilarity = 0.6,
    pageNumber = 0,
    itemsPerPage = 10,
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("consultationrequest/getconsultationrequestbysenderid", {
        params: {
            senderId,
            keyword,
            tauxsimilarity,
            page: pageNumber,
            size: itemsPerPage,
            sortList,
            sortOrder
        }
    });

};


export const getConsultationRequestByReceiverId = (
    receiverId,
    keyword = "",
    tauxsimilarity = 0.6,
    pageNumber = 0,
    itemsPerPage = 10,
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("consultationrequest/getconsultationrequestbyreceiverid", {
        params: {
            receiverId,
            keyword,
            tauxsimilarity,
            page: pageNumber,
            size: itemsPerPage,
            sortList,
            sortOrder
        }
    });

};


export const getConsultationRequestBySenderIdOrReceiverId = (
    senderId,
    receiverId,
    keyword = "",
    tauxsimilarity = 0.6,
    pageNumber = 0,
    itemsPerPage = 10,
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("consultationrequest/getconsultbysenderidorreceiverid", {
        params: {
            senderId,
            receiverId,
            keyword,
            tauxsimilarity,
            page: pageNumber,
            size: itemsPerPage,
            sortList,
            sortOrder
        }
    });

};



export const getAllConsultationRequest = (
    keyword = "",
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("consultationrequest/getall", {
        params: {
            keyword,
            sortList,
            sortOrder
        }
    });

};

export const deleteConsultationRequest = (id) => {
    return myAxios.delete(`consultationrequest/delete/${id}`);
};

// =======================================================
// Recherche
// =======================================================

export const findSimilarConsultationRequest = (
    keyword,
    tauxsimilarity = 0.6,
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("consultationrequest/similarity", {
        params: {
            keyword,
            tauxsimilarity,
            sortList,
            sortOrder
        }
    });

};

// =======================================================
// Métier
// =======================================================

export const getConsultationRequestByConsultationRequestId = (
    consultationRequestId,
    sortList = [],
    sortOrder = "ASC"
) => {

    return myAxios.get(
        `consultationrequest/getallbyconsultationrequest/${consultationRequestId}`,
        {
            params: {
                sortList,
                sortOrder
            }
        }
    );

};

export const countAllConsultations = (
) => {
    return myAxios.get("consultationrequest/countallconsultations", {
    });
};

export const countCompletedConsultations = (
) => {
    return myAxios.get("consultationrequest/countcompletedconsultations", {
    });
};

export const countPendingConsultations = (
) => {
    return myAxios.get("consultationrequest/countpendingconsultations", {
    });
};